export const languageEN =
    {
        cookieModalTitle:"Cookies settings",
        cookieModalContext:"In addition to the cookies that are necessary for the operation of this website, we use the following types of cookies to improve your experience on the website and our services: Functionality cookies, to improve your experience on the website (e.g. remembering your settings), Performance cookies, to measure site performance and improve your user experience, advertising/targeting cookies, which are set by third parties with whom we run advertising campaigns and allow us to deliver advertisements relevant to you. Please see our cookie policy for more information.",
        cookieButtonAccept:"Accept all cookies",
        cookieButtonOptions:"Cookies customization",
        cookieCheckboxTitle1:"I accept all cookies described below",
        cookieCheckboxDesc1:"Cookies that allow us to improve your experience on the website (e.g. by remembering the settings you choose).",
        cookieCheckboxTitle2:"I accept the following performance cookies",
        cookieCheckboxDesc2:"Website performance cookies, which allow us to evaluate the quality of the website and improve your experience on the website. When using quality cookies, we do not collect any personal data and only use the information collected through these cookies in an aggregated and anonymous form.",
        cookieCheckboxTitle3:"I accept the following advertising/targeting cookie",
        cookieCheckboxDesc3:"Marketing/targeting cookies that we use to track user activity and sessions so that we can provide more personalized services. Marketing cookies are set by third parties with whom we run marketing campaigns and enable us to deliver marketing materials that are relevant to you",
        cookieOptionsAccept:"Accept",
        cookieTableHeader:"Functional",
        cookieHeading:"Cookie name",
        cookieTableContext:"controlCookie, advertisingCookies, mandatoryCookies, performanceCookies",
        cookieHeading2:"Cookie owner",
        cookieTableContext2:"EY",
        cookieHeading3:"Purpose of the cookie",
        cookieTableContext3:"Stores information about the user's response to the cookie terms.",
        cookieHeading4:"Cookie type",
        cookieTableContext4:"Own	",
        cookieHeading5:"Cookie lifetime",
        cookieTableContext5:"30 days	",
        cookieTableHeader2:"Performance cookies",
        cookieHeading6:"Cookie name",
        cookieTableContext6:"_pk_id.<appID>.<domainHash>",
        cookieTableContext6_2:"pk_ses.<appID>.<domainHash>",
        cookieTableContext6_3:"stg_last_interaction",
        cookieTableContext6_4:"stg_returning_visitor",
        cookieTableContext6_5:"stg_traffic_source_priority",
        cookieHeading7:"Cookie owner",
        cookieTableContext7_1:"Piwik",
        cookieTableContext7_2:"Piwik",
        cookieTableContext7_3:"Piwik",
        cookieTableContext7_4:"Piwik",
        cookieTableContext7_5:"Piwik",
        cookieHeading8:"Purpose of the cookie",
        cookieTabContext8_1:"Used to recognize visitors and store their local data.",
        cookieTabContext8_2:"Shows the visitor's active session. If the cookie does not exist, the session ended more than 30 minutes ago and was counted in the pk_id cookie.",
        cookieTabContext8_3:"Specifies whether the last visitor's session is still running or a new session has started.",
        cookieTabContext8_4:"Determines if the visitor has already been to your site and returned.",
        cookieTabContext8_5:"Stores the traffic source type that explains how the visitor arrived at your site.",
        cookieHeading9:"Cookie type",
        cookieTabContext9_1:"Third party",
        cookieTabContext9_2:"Third party",
        cookieTabContext9_3:"Third party",
        cookieTabContext9_4:"Third party",
        cookieTabContext9_5:"Third party",
        cookieHeading10:"Cookie liftime",
        cookieTabContext10_1:"13 months",
        cookieTabContext10_2:"30 minutes",
        cookieTabContext10_3:"365 days",
        cookieTabContext10_4:"365 days",
        cookieTabContext10_5:"30 minutes",
        cookieTableHeader3:"Advertising cookies",
        cookieHeading11:"Cookie name",
        cookieTabContext11_1:"ln_or",
        cookieTabContext11_2:"_gcl_au",
        cookieHeading12:"Cookie owner",
        cookieTabContext12_1:"LinkedIn",
        cookieTabContext12_2:"Google",
        cookieHeading13:"Purpose of the cookie",
        cookieTabContext13_1:"Specifies whether Oribi analysis can be performed on the specified domain",
        cookieTabContext13_2:"Used as a conversion linker in web and AMP containers that can be configured to combine data when landing pages and conversion pages are embedded on different domains. Used by Google Adsense",
        cookieHeading14:"Cookie type",
        cookieTabContext14_1:"Third party",
        cookieTabContext14_2:"Third party",
        cookieHeading15:"Cookie lifetime",
        cookieTabContext15_1:"1 day",
        cookieTabContext15_2:"90 days",
        cookieOptionsDesc:"Cookies settings",
        loaderTitle:"Please wait...",
        loaderDesc:"Results are being generated",
        sucessTitle:"Finished!",
        successDesc:"Thank you for filling out the form, confirmation with the results was sent by e-mail ",
        buttonBack:"Back",
        buttonForward:"Next",
        buttonSubmit:"Check the results",
        buttonHomePage:"Back to homepage"
    }
